import React, { PureComponent } from 'react';
import TableC from '../../../basicElement/TableC';
import renderEnhancer from '../../../shared/renderEnhancer';
import format from '../../../shared/format';
import { Default } from '../constants';

const markMain = (text, record) => {
    const { isMain, teacherWorkStatus } = record;
    return text ? <span style={{ color: teacherWorkStatus === 'LEFT' && '#ccc' }}>{`${text}${isMain == 1 ? '(主)' : ''}`}</span> : '';
};
const mapKeyToValue = (text) => Default[text];
const showReason = (index) => {
    return (text, record) => {
        const reportFailReason = record[`reportFailReason${index}`] || '';
        let comment = record[`comment${index}`];
        comment = comment ? `(${comment})` : '';
        return `${reportFailReason}${comment}`;
    };
};

export default class PromotionList extends PureComponent {
    showSheet = (index) => {
        return (text, record) => {
            return <a onClick={() => this.props.showSheet(index, record)}>{text}</a>;
        };
    } 
    
    getColumns = () => {
        const { rewardReport, showChangeLog } = this.props;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            fixed: 'left',
            render: renderEnhancer(),
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '主管领导',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
            render: renderEnhancer(),
        }, {
            title: '入职时间',
            dataIndex: 'joinTime',
            key: 'joinTime',
            width: 80,
            render: renderEnhancer(text => format('date', text)),
        }, {
            title: '转正时间',
            dataIndex: 'positiveTime',
            key: 'positiveTime',
            width: 80,
            render: renderEnhancer(text => format('date', text)),
        }, {
            title: '专业',
            dataIndex: 'specialType',
            key: 'specialType',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '独立承接项目时间',
            dataIndex: 'independentInvTime',
            key: 'independentInvTime',
            width: 80,
            render: renderEnhancer(text => format('date', text)),
        }, {
            title: '承接情况说明',
            dataIndex: 'invUndertakeDescription',
            key: 'invUndertakeDescription',
            width: 120,
            render: renderEnhancer(),
        }, {
            title: '状态',
            dataIndex: 'workStatusShow',
            key: 'workStatusShow',
            width: 60,
            render: renderEnhancer(),
        }, {
            title: '离职时间',
            dataIndex: 'leftTime',
            key: 'leftTime',
            width: 80,
            render: renderEnhancer(text => format('date', text)),
        }, {
            title: '离职原因',
            dataIndex: 'firstReasonName',
            key: 'firstReasonName',
            width: 160,
            render: renderEnhancer(),
        }, {
            title: '带教老师工号',
            dataIndex: 'teacherCode',
            key: 'teacherCode',
            width: 100,
            render: markMain
        }, {
            title: '带教老师姓名',
            dataIndex: 'teacherName',
            key: 'teacherName',
            width: 100,
            render: markMain
        }, {
            title: '是否到达第一阶段评估时间',
            dataIndex: 'isArriveFirstEvaluate',
            key: 'isArriveFirstEvaluate',
            width: 100,
            render: mapKeyToValue,
        }, {
            title: '第一阶段评估得分',
            dataIndex: 'firstEvaluateScore',
            key: 'firstEvaluateScore',
            width: 80,
            render: this.showSheet('0'),
        }, {
            title: '是否到达第二阶段评估时间',
            dataIndex: 'isArriveSecondEvaluate',
            key: 'isArriveSecondEvaluate',
            width: 100,
            render: mapKeyToValue,
        }, {
            title: '第二阶段评估得分',
            dataIndex: 'secondEvaluateScore',
            key: 'secondEvaluateScore',
            width: 80,
            render: this.showSheet('1'),
        }, {
            title: '是否到达新人独立承接项目评估时间',
            dataIndex: 'isNewIndependent',
            key: 'isNewIndependent',
            width: 120,
            render: mapKeyToValue,
        }, {
            title: '新人独立承接项目评估得分',
            dataIndex: 'newIndependentEvaluateScore',
            key: 'newIndependentEvaluateScore',
            width: 100,
            render: this.showSheet('2'),
        }, {
            title: '带教奖上报',
            children: [{
                title: '上报情况',
                dataIndex: 'reportInfo1',
                key: 'reportInfo1',
                width: 120,
            }, {
                title: '没有上报成功的原因',
                dataIndex: 'reportFailReason1',
                key: 'reportFailReason1',
                width: 140,
                render: showReason(1),
            }]
        }, {
            title: '出师奖上报',
            children: [{
                title: '上报情况',
                dataIndex: 'reportInfo2',
                key: 'reportInfo2',
                width: 120,
            }, {
                title: '没有上报成功的原因',
                dataIndex: 'reportFailReason2',
                key: 'reportFailReason2',
                width: 140,
                render: showReason(2),
            }]
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'right',
            width: 120,
            render: renderEnhancer(
                (text, record) => {
                    const { hasTeacher, rewardCanEdit } = record;
                    return (
                        <span>
                            {
                                (rewardCanEdit && hasTeacher) &&
                                <span>
                                    <a onClick={() => rewardReport(record)}>奖励上报</a>
                                    <span className="ant-divider" />
                                </span>
                            }
                            <a onClick={() => showChangeLog(record)}>带教老师变更日志</a>
                        </span>
                    );
                }
            ),
        }];
        return columns;
    };

    render() {
        const { loading, data, pagination, onChange } = this.props;
        const scrollY = (document.body || document.documentElement).clientHeight - 250;
        return (
            <TableC
                loading={loading}
                columns={this.getColumns()}
                data={data}
                scrollY={scrollY}
                pagination={pagination}
                onChange={onChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/PromotionList.js